import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  HireDotNetExtensive,
  HireDotNetCertified,
  HireDotNetCustomized,
  HireDotNetSeamless,
  HireDotNetTimely,
  HireDotNetSupport,
} from "../../../app-constants";

function Whychoosespeeech() {
  return (
    <section
      className="voice_services why_choose_speech p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Why Choose TekRevol to Hire .NET Developers</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Having had many years of experience in .NET development, TekRevol
              provides the best solutions that are highly reliable, scalable,
              and secure to fit your software solutions. Our hard-working and
              highly qualified team of specialists in the field of .NET exceeds
              your expectations. These values include quality, efficiency, and
              innovation, which are hallmarks of any project we undertake and
              any work we do for our clients.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {HireDotNetExtensive}
                    </div>
                    <div className="voice_service_head">
                      <h5>Extensive Experience</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Our developers have extensive experience across diverse
                      industries and projects.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {HireDotNetCertified}
                    </div>
                    <div className="voice_service_head">
                      <h5>Certified Professionals</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We provide certified .NET professionals with proven
                      technical expertise.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {HireDotNetCustomized}
                    </div>
                    <div className="voice_service_head">
                      <h5>Customized Solutions</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We deliver tailor-made .NET solutions that align with your
                      specific business requirements.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {HireDotNetSeamless}
                    </div>
                    <div className="voice_service_head">
                      <h5>Seamless Communication</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We ensure seamless communication and collaboration
                      throughout the project lifecycle.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{HireDotNetTimely}</div>
                    <div className="voice_service_head">
                      <h5>Timely Delivery</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We prioritize timely delivery without compromising on
                      quality.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{HireDotNetSupport}</div>
                    <div className="voice_service_head">
                      <h5>Ongoing Support</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We offer continuous support and maintenance to keep your
                      applications running smoothly.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
